<template>
  <router-view
    class="software-license"
    :cpf.sync="cpf"
  />
</template>

<script>

export default {
  data: () => ({
    cpf: '',
  }),
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.software-license
  min-width: 300px
  max-width: 800px
  height: 36em
  +media-min-sm()
    min-width: 600px
  +media-min-md()
  +media-min-lg()
</style>
